import { AddCircle } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddRemoteTargetsDialog } from './AddRemoteTargetsDialog';
import { AddRemoteTargetsValue } from './AddRemoteTargetsValue';

export interface RemoteTargetDevice {
  id: number;
  name: string;
}

export interface AddRemoteTargetsProps {
  currentDeviceId: number;
  onChange: (ids: number[]) => void;
  remoteTargets: readonly RemoteTargetDevice[];
}

export const AddRemoteTargets = ({
  currentDeviceId,
  onChange,
  remoteTargets: initialRemoteTargets,
}: AddRemoteTargetsProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const [remoteTargets, setRemoteTargets] = useState<RemoteTargetDevice[]>([
    ...initialRemoteTargets,
  ]);

  const handleRemoteTargetsChange = (devices: RemoteTargetDevice[]) => {
    setRemoteTargets(devices);
    onChange(devices.map((d) => d.id));
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
        {remoteTargets
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((target) => (
            <AddRemoteTargetsValue
              key={target.id}
              id={target.id}
              name={target.name}
              onRemove={() => {
                const updated = remoteTargets.filter((x) => x.id !== target.id);
                setRemoteTargets(updated);
                onChange(updated.map((x) => x.id));
              }}
            />
          ))}
      </Box>

      <Button
        color="primary"
        onClick={() => setOpen(true)}
        startIcon={<AddCircle />}
        variant="contained"
      >
        {t('pages.devices.show.remote_targets.add_devices')}
      </Button>

      {open && (
        <AddRemoteTargetsDialog
          currentDeviceId={currentDeviceId}
          fullWidth
          onClose={() => setOpen(false)}
          onChange={handleRemoteTargetsChange}
          open
          remoteTargets={remoteTargets}
        />
      )}
    </>
  );
};
